//Formulario de visita que se llena presencialmente 

// Imports 
import React, {createRef} from 'react';
import {Link} from 'react-router-dom';
import {Card, Row, Col, Form, Input, Button, Select, notification, Modal, Avatar, Space, Radio, Divider, Spin, Upload, message, DatePicker, Breadcrumb, Result} from 'antd';
import ImgCrop from 'antd-img-crop';
import {LoadingOutlined, UploadOutlined, ExclamationCircleOutlined, SearchOutlined, CheckCircleTwoTone, CloseCircleTwoTone, ExclamationCircleTwoTone} from '@ant-design/icons';
import moment from 'moment';
import {
    getSponsorsParams,
    getTypesVisits,
    getCiudades,
    getMunicipios,
    getOrganismos,
    getPaises,
    getRegiones,
    checkrut,
    getOrganismosRepart,
    getEstadosCiviles,
    getFormVisitRut,
    crearFormularioPresencial
} from "./VisitConsumer";
import 'antd/dist/antd.css';
import axios from "axios/index";


const {confirm} = Modal;
const {Option} = Select;
const {RangePicker} = DatePicker;

const form = createRef();
const formSponsor = createRef();

// Funcion de lectura de imagen
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

// Verifica el tipo de imagen (jpg, png)
function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Imagen debe ser mas pequeña que 2MB!');
    }
    return isJpgOrPng && isLt2M;
}

function getMeta(file){
    return new Promise (function (resolved, rejected) {
        var i = new Image()
        i.onload = function(){
        resolved({w: i.width, h: i.height})
        };
        i.src = file
    }) 
}

// Se debe modificar a una base de datos de prefijos de paises
const prefixSelector = (
    <Form.Item name="prefix" noStyle>
        <Select className="telefono">
            <Option value="56">+56</Option>
        </Select>
    </Form.Item>
);

// Validaciones
/* eslint-disable no-template-curly-in-string */
const validateMessages = {
    required: '${label} es requerido',
    types: {
        email: '${label} no es válido como email',
        number: '${label} no es un número válido',
    },
    number: {
        range: '${label} debe estar entre ${min} y ${max}',
    },
};

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

const borrarCampos=()=>{
    form.current.resetFields()
}


// Componente que se muestra finalmente
class FormVisit extends React.Component {
    state = {
        loading: false,
        funcionarios: [],
        visitas: [],
        boolRut: false,
        ciudades: [],
        municipios: [],
        regiones:[],
        paises: [],
        organismos_data: [],
        organismos: [],
        reparticiones: [],
        departamentos: [],
        estados_civiles: [],
        image: null,
        filtered_regiones: [],
        filtered_ciudades: [],
        filtered_municipios: [],
        loadings: [],
        visita: [],
        pais_length: '',
        region_length: '',
        ciudad_length: '',
        municipios_length: '',
        organismos_length: '',
        visible: false,
        checkValue: '0',
        loadingSponsorButton: 0,
        ingresarNombres: '',
        dataUser: "",
        esChile: true,
        datosFormulario: [],
        visitaSinCargar: true,
        nivelTresSeleccionado: false,
        modalWidth:'240px',
        modalOk: false,
        modalNotOk : false,
        submitButtonload: false,
        nombreFacultadSeleccionada: '',
        modalProrrogaOk: false,
        modalEsUChile: false,
        modalEsVigente: false,
        modalEmailNotOk: false

    };

    beforeCrop= (info) => {
        getBase64(info, imageUrl => {
            getMeta(imageUrl).then((response) => {
                let dimensionW = response.w;
                if(dimensionW > 600){
                    this.setState({modalWidth: '600px'});
                }else{
                    this.setState({modalWidth: dimensionW.toString()+'px'});
                }
            });
        });
        return info;
    }

    datosCampos= () =>{
        console.log("fields:",form.current.getFieldValue())
        console.log("image: ", this.state.image)
    }

    datosCamposSponsor= () =>{
        console.log("fields:",formSponsor.current.getFieldValue())
    }

    enterLoading = index => {
        this.setState(({loadings}) => {
            const newLoadings = [...loadings];
            newLoadings[index] = true;
            return {
                loadings: newLoadings,
            };
        });
    };

    componentDidMount() {
        // Consultas a la API para rellenar las boxes del formulario
        getEstadosCiviles().then((response) => {
            this.setState({estados_civiles: response.data})
        });
        getTypesVisits().then((response) => {
            this.setState({visitas: response.data})
        });
        getCiudades().then((response) => {
            this.setState({ciudades: response.data, ciudad_length: this.calcular_largo(response.data,10), visitaSinCargar: false});
        });
        getMunicipios().then((response) => {
            this.setState({municipios: response.data.municipio});
        });
        getPaises().then((response) => {
            this.setState({paises: response.data, pais_length: this.calcular_largo(response.data,10)});
        });
        getRegiones().then((response) => {
            this.setState({regiones: response.data, region_length: this.calcular_largo(response.data,10)});
            // Valor default del País
            this.setState({
                filtered_regiones :  response.data.filter((region)  => parseInt(region.id_pais) === window.ENV.CONSTANTE_ID_CHILE)
            });
        });
        getOrganismos().then((response1) => {
            let reparticion_data = response1.data.filter( (organismo) => parseInt(organismo.nivel) === 2);
            this.setState({
                organismos_data: response1.data,
                reparticiones: reparticion_data,
                organismos_length: this.calcular_largo(response1.data,9)
            });
            getOrganismosRepart(window.Roles[0].code).then((response2) => {
                if(window.Roles[0].Permisos[0] === "page_registrar_visita"){
                    let reparticionUser = reparticion_data.filter((organismo) => parseInt(response2.data[0].id_organismo_padre) === organismo.id_organismo)
                    let organismoUser = response1.data.filter((organismo) => parseInt(response2.data[0].id_organismo) === organismo.id_organismo)
                    this.setState({
                        organismos: organismoUser,
                        reparticiones: reparticionUser
                    })
                    this.handleonChange_reparticion(response2.data[0].id_organismo_padre)
                    this.handleonChange_organismo(response2.data[0].id_organismo)
                    form.current.setFieldsValue({
                        unidad: {reparticion: response2.data[0].id_organismo_padre, organismo: response2.data[0].id_organismo}
                    })
                }
                this.setState({dataUser: response2.data[0]})
            });
        });
    };

    calcular_largo(data_array,pix_multi) {
        let string_length = 0;
        data_array.map(info => {
            if(string_length < info.nombre.length){
                string_length = info.nombre.length;
            }
        })
        string_length = string_length*pix_multi;
        return(string_length.toString()+'px')
    }

    // Informacion de subida de imagen
    handleChange = info => {
        /*if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;form.current.resetFields()
        }
        if (info.file.status === 'done') {*/
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, imageUrl =>
                this.setState({
                    imageUrl,
                    loading: false,
                }),
            );
            this.setState({image: info.file.originFileObj});
        //}
    };

    //Mostrar el modal de patrocinadores
    showModal = (indice) => {
        this.setState({
            index: indice,
            visible: true,
        });
    };

    // Cerrar el modal 
    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };
    
    handleonChangeRutPasaportev2 = data => {
        this.setState({visitaSinCargar : true})
        if(!data.target.value){
            console.log("vacio");
            this.setState({visitaSinCargar : false})
            return;
        }
        let rutRecibido = data.target.value
        if(rutRecibido[0] === 'p'){
            this.setState({visitaSinCargar : false})
            return;
        }
        if(rutRecibido[0].toUpperCase() != "P"){
            var dataF = rutRecibido.replace("-","")
            for(let ix=0;ix<10-rutRecibido.replace("-","").length;ix++){
                dataF = "0" + dataF;
            }
        } else {
            var dataF = data.target.value;
        }
        checkrut(dataF.toUpperCase()).then(respCheckRut => {
            if(respCheckRut.data.esUChile){
                this.setState({visitaSinCargar : false})
                this.setState({modalEsUChile: true});
                return;
            }
            if(respCheckRut.data.esVigente){
                this.setState({visitaSinCargar : false})
                this.setState({modalProrrogaOk: true});
                return;
            }
            if (respCheckRut.data.verificacion) {
                getFormVisitRut(dataF.toUpperCase()).then((response) => {
                    let res = [response.data]
                    let rutIngresado = form.current.getFieldValue().rut_pasaporte
                    if (res.length > 0 && res[0].id_visita != -1){
                        /* const res2 = this.state.ciudades.filter(function (ciudad) {
                            return [res[0].ID_FORMULARIO.IdCiudad].indexOf(ciudad?.id_ciudad) >= 0;
                        }); */
                        this.setState({visita: res[0]});
                        //AGREGAR ESTADO CIVIL
                        if(res[0].ID_FORMULARIO.IdEstadoCivil === 0){
                            res[0].ID_FORMULARIO.IdEstadoCivil = 1
                        }
                        if(res[0].ID_FORMULARIO.IdNacionalidad === 0){
                            res[0].ID_FORMULARIO.IdNacionalidad = window.ENV.CONSTANTE_ID_CHILE
                        }
                        if(res[0].ID_FORMULARIO.IdPais == window.ENV.CONSTANTE_ID_CHILE && res[0].ID_FORMULARIO.IdRegion != 0 && res[0].ID_FORMULARIO.IdCiudad != 0){
                            this.handleonChange_pais(res[0].ID_FORMULARIO.IdPais)
                            this.handleonChange_region(res[0].ID_FORMULARIO.IdRegion)
                            form.current.setFieldsValue({
                                rut_pasaporte: rutIngresado,
                                nombres: res[0].ID_FORMULARIO.Nombres,
                                paterno: res[0].ID_FORMULARIO.Paterno,
                                materno: res[0].ID_FORMULARIO.Materno,
                                user: {email: res[0].ID_FORMULARIO.Email},
                                nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais, region: res[0].ID_FORMULARIO.IdRegion, city: res[0].ID_FORMULARIO.IdCiudad},
                                birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                gender: res[0].ID_FORMULARIO.Genero,
                                phone: res[0].ID_FORMULARIO.Telefono + "",
                                estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                            })
                        } else {
                            this.handleonChange_pais(res[0].ID_FORMULARIO.IdPais)
                            //this.handleonChange_region(-1) //-1 para que no encuentre ninguna region
                            if(res[0].ID_FORMULARIO.IdCiudad != 0){
                                form.current.setFieldsValue({
                                    rut_pasaporte: rutIngresado,
                                    nombres: res[0].ID_FORMULARIO.Nombres,
                                    paterno: res[0].ID_FORMULARIO.Paterno,
                                    materno: res[0].ID_FORMULARIO.Materno,
                                    user: {email: res[0].ID_FORMULARIO.Email},
                                    nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                    address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais, city: res[0].ID_FORMULARIO.IdCiudad},
                                    birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                    gender: res[0].ID_FORMULARIO.Genero,
                                    phone: res[0].ID_FORMULARIO.Telefono + "",
                                    estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                                })
                            } else {
                            form.current.setFieldsValue({
                                rut_pasaporte: rutIngresado,
                                nombres: res[0].ID_FORMULARIO.Nombres,
                                paterno: res[0].ID_FORMULARIO.Paterno,
                                materno: res[0].ID_FORMULARIO.Materno,
                                user: {email: res[0].ID_FORMULARIO.Email},
                                nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais},
                                birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                gender: res[0].ID_FORMULARIO.Genero,
                                phone: res[0].ID_FORMULARIO.Telefono + "",
                                estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                            })
                        }
                        }
                    } else {
                        form.current.resetFields()
                        form.current.setFieldsValue({
                            rut_pasaporte: rutIngresado,
                        })
                    }
                    this.setState({visitaSinCargar: false});
                });
            } else {
                let rutIngresado = form.current.getFieldValue().rut_pasaporte
                form.current.resetFields()
                form.current.setFieldsValue({
                    rut_pasaporte: rutIngresado,
                })
                this.setState({visita: [],visitaSinCargar: false});
            }
        });
    };

    // Filtra regiones cuando el pais cambia
    handleonChange_pais = (value,event) => {
        form.current.setFieldsValue({
            address: {region: null, city: null},
        })
        if(value !== window.ENV.CONSTANTE_ID_CHILE){
            let ciudades =  this.state.ciudades;
            this.setState({esChile: false,
                filtered_regiones : [],
                filtered_municipios: [],
                filtered_ciudades :  ciudades.filter((ciudad)  => parseInt(ciudad.id_pais) === parseInt(value))
            });
            return
        } else {
            this.setState({esChile: true})
        }
        var regiones =  this.state.regiones
        this.setState({
            filtered_regiones :  regiones.filter((region)  => parseInt(region.id_pais) === parseInt(value)),
            filtered_ciudades : [],
            filtered_municipios: []
        });
    }

    //Filtra ciudades si el país cambia
    handleonChange_region = (value,event) => {
        form.current.setFieldsValue({
            address: {city: null},
        })
        if (this.state.esChile){
            let municipios = this.state.municipios;
            console.log("Municipios: ", municipios)
            this.setState({
                filtered_municipios :  municipios.filter((municipio)  => parseInt(municipio.id_region) === parseInt(value))
            });
        } else {
            let ciudades =  this.state.ciudades;
            this.setState({
                filtered_ciudades :  ciudades.filter((ciudad)  => parseInt(ciudad.id_region) === parseInt(value))
            });
        }
    }

    //Filtra organismos si la reparticion cambia
    handleonChange_reparticion = (value,event) => {
        let organismos;
        if(form.current.getFieldValue("sponsor")){
            form.current.setFieldsValue({sponsor: null })
        }
        if(window.Roles[0].Permisos[0] === "registrar_visita_superadmin"){
            if(form.current.getFieldValue("unidad").organismo){
                form.current.setFieldsValue({unidad: {organismo: null} })
            }
            if(form.current.getFieldValue("unidad").departamento){
                form.current.setFieldsValue({unidad: {departamento: null} })
            }
            this.setState({nivelTresSeleccionado: false})
        }
        if(window.Roles[0].Permisos[0] === "page_registrar_visita"){
            organismos =  this.state.organismos
        } else {
            organismos =  this.state.organismos_data
        }
        this.setState({
            organismos:  organismos.filter((organismo)  => parseInt(organismo.id_organismo_padre) === parseInt(value)),
            funcionarios: []
        });
    }

    //Filtra departamentos si el organismo cambia
    handleonChange_organismo = (value,event) => {
        var organismos =  this.state.organismos_data
        var nombreFacultad = organismos.filter((organismo)  => parseInt(organismo.id_organismo) === parseInt(value))
        if(form.current.getFieldValue("sponsor")){
            form.current.setFieldsValue({sponsor: null })
        }
        if(window.Roles[0].Permisos[0] === "registrar_visita_superadmin"){
            if(form.current.getFieldValue("unidad").departamento){
                form.current.setFieldsValue({unidad: {departamento: null} })
            }
        }
        this.setState({
            departamentos :  organismos.filter((organismo)  => parseInt(organismo.id_organismo_padre) === parseInt(value)),
            nivelTresSeleccionado: true,
            nombreFacultadSeleccionada: nombreFacultad[0].nombre,
            funcionarios: []
        });
    }

    submitForm = () => {
        this.setState({submitButtonload: true});
        let rutRecibido = form.current.getFieldValue('rut_pasaporte');
        if(rutRecibido == undefined){
            this.setState({submitButtonload: false});
            form.current.submit();
            return;
        }
        if(rutRecibido[0] === 'p'){
            this.setState({visitaSinCargar : false})
        }else{
            if(rutRecibido[0].toUpperCase() != "P"){
                var dataF = rutRecibido.replace("-","")
                for(let ix=0;ix<10-rutRecibido.replace("-","").length;ix++){
                    dataF = "0" + dataF;
                }
            } else {
                var dataF = form.current.getFieldValue('rut_pasaporte');
            }
            checkrut(dataF.toUpperCase()).then(respCheckRut => {
                this.setState({submitButtonload: false});
                if(respCheckRut.data.esUChile){
                    this.setState({modalEsUChile: true});
                }else if(respCheckRut.data.esVigente){
                    this.setState({modalProrrogaOk: true});
                }else{
                    form.current.submit();
                }
            })
        }
    }

    // Formulario
    render() {
        const onChangeCheckbox = e => {
            let valor = e.target.value
            formSponsor.current.resetFields();
            formSponsor.current.setFieldsValue({
                checkRutSponsor: valor
            })
            this.setState({checkValue: valor})
        };

        const searchSponsor = values => {
            values.checkRut = values.checkRutSponsor
            if(values.checkRutSponsor === '0'){
                var dataF = values.rut_pasaporte.replace("-","")
                for(let ix=0;ix<10-values.rut_pasaporte.replace("-","").length;ix++){
                    dataF = "0" + dataF
                }
                values.rut_pasaporte = dataF.toUpperCase()
            } else {
                if((!values.nombres)){
                    this.setState({ingresarNombres: "Debe ingresar por lo menos un campo"});
                    return
                } else {
                    this.setState({ingresarNombres: ""});
                } 
            }
            values.nivelTres = form.current.getFieldValue("unidad").organismo;
            values.dataUser = window.Roles[0].code;
            this.setState({loadingSponsorButton: 1});
            getSponsorsParams(values).then(res => {
                this.setState({funcionarios: [res.data],loadingSponsorButton: 0})
            }).catch(function (error) {
                console.log(error)
                this.setState({loadingSponsorButton: 0});
            })
        };

        const setSponsor = values => {
            form.current.setFieldsValue({
                sponsor: parseInt(values)
            })
            this.handleCancel()
        }

        const renderSponsors = () => {
            if(this.state.funcionarios.length > 0){
                if(this.state.funcionarios[0][0].nombres == "notfound"){
                    return(<div>{"No se encontraron resultados."}</div>)
                } else {
                    return(<div> Resultados: <br/>{this.state.funcionarios[0].map(sponsor => (
                    <div> <Button type="link" onClick={() => {setSponsor(sponsor.id_persona)}}> {sponsor.nombres} {sponsor.paterno} {sponsor.materno} </Button> </div>
                ))} </div> )
                }
            } else {
                return (null)
            }
        }

        const initialSponsor = { checkRutSponsor: "0"};
        
        const showModalOk = () => {
            this.setState({
                modalOk: true,
            });
        };

        const showModalProrrogaOk = () => {
            this.setState({
                modalProrrogaOk: true,
            });
        }

        const hideModalProrrogaOk = () => {
            this.setState({
                modalProrrogaOk: false,
                submitButtonload: false
            });
        }

        const showModalEmailNotOk = () => {
            this.setState({
                modalEmailNotOk: true,
            });
        };

        const hideModalEmailNotOk= () => {
            this.setState({
                modalEmailNotOk: false,
                submitButtonload: false
            });
        }

        const showModalNotOk = () => {
            this.setState({
                modalNotOk: true,
            });
        };

        const hideModalNotOk = () => {
            this.setState({
                modalNotOk: false,
                submitButtonload: false,
            });
        };

        const hideModalOk = () => {
            this.setState({
                modalOk: false,
                submitButtonload: false,
            });
        };

        const buttonNotLoading = () => {
            this.setState({
                submitButtonload: false,
            });
        };
        
        //TODO: Manejo de errores 503, 400 y otros
        //Se debe modificar para que haga la conenexion a la base de datos
        const onFinish = values => {
            this.setState({submitButtonload: true})
            values.depart = this.state.departamentos
            values.user.email = values.user.email.toLowerCase()
            if(this.state.image){
                values.photo = this.state.image;
            } else {
                values.photo = null;
            }
            if(!values.photo && !this.state.visita.ID_FORMULARIO.FotoPersona){
                this.setState({submitButtonload: false})
                notification.open({
                    message: "Error",
                    description: "Debe subir una foto si la visita es nueva",
                    type: "error",
                    duration: 10,
                });
                return
            }
            values.tiene_foto = values.photo === null && this.state.visita.ID_FORMULARIO.FotoPersona !== ""
            if(!values.materno){
                values.materno = ''
            }
            if(!values.address.city){
                values.address.city = null
            }
            if(this.state.visita.ID_FORMULARIO){
                values.idFormulario = this.state.visita.ID_FORMULARIO.IdFormularioVisita
            }else {
                values.idFormulario = null
            }

            if(values.rut_pasaporte[0].toUpperCase() != "P"){
                var dataF = values.rut_pasaporte.replace("-","")
                for(let ix=0;ix<10-values.rut_pasaporte.replace("-","").length;ix++){
                    dataF = "0" + dataF
                }
                values.rut_pasaporte = dataF
            }
            const enterLoading = this.enterLoading;
            values.rut_pasaporte = values.rut_pasaporte.toUpperCase();
            //Pop up de confirmacion antes del envio 
            confirm({
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                content: <div><div style={{textAlign:"center", marginBottom: "40px"}}><ExclamationCircleOutlined style={{fontSize: "60px", color: "#FFBA5C"}}/></div><div style={{fontSize: "19px", color:"#8190A5", marginBottom: "20px", textAlign:"center"}}>¿Está seguro de ingresar esta visita?</div></div>,
                cancelButtonProps: {className: 'global-secundario-button'},
                okButtonProps: {className: 'global-principal-button'},
                width:"600px",
                 onOk() {
                    crearFormularioPresencial(values).then(function (response) {
                        if(response.data.insertado === 1){
                            showModalOk()
                        }
                        if(response.data.insertado === -1) {
                            showModalEmailNotOk()
                        }
                        if(response.data.insertado === 0){
                            showModalProrrogaOk()
                        }
                    }).catch(function (error) {
                        showModalNotOk()
                    });
                    enterLoading(0);
                },
                onCancel(){
                    buttonNotLoading()
                },
            });
        };

        // Funcion de Upload de imagen
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined style={{color:"#116EC0"}}/> : <UploadOutlined style={{color:"#116EC0", fontSize:"25px"}} />}
                <div className='formvisit-upload-text'/* style={{color: "#116EC0", fontSize:"13px"}} */><b>SUBIR FOTO</b></div>
            </div>
        );

        // Cambio de URL de la imagen cuando es subida
        const {imageUrl} = this.state;

        // para boton loading
        const {loadings} = this.state;

        

        return (
            <div>
                <div>
                    <Modal visible={this.state.modalEsUChile} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                            <ExclamationCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FFBA5C"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Este RUT/Pasaporte ya tiene un vínculo con la Universidad y no se puede crear como visita</div>
                        <Divider style={{background: '#969FAA'}}/>
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => this.setState({modalEsUChile: false})} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalEsVigente} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                            <ExclamationCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FFBA5C"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Este RUT/Pasaporte ya tiene una visita vigente</div>
                        <Divider style={{background: '#969FAA'}}/>
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => this.setState({modalEsVigente: false})} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <CheckCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#52c41a"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Creación de visita exitosa</div>
                        <Divider style={{background: '#969FAA'}}/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => window.location.reload()} >ACEPTAR</Button>
                            {/* <Button className='global-principal-button' onClick={() => {hideModalOk()}} >BORRAR DESPUES</Button> */}
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalNotOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Ocurrió un error al ingresar la visita, intentelo nuevamente.</div>
                        <Divider style={{background: '#969FAA'}}/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => {hideModalNotOk()}} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalEmailNotOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Este mail está asociado a otro usuario. Por favor pruebe con otro mail.</div>
                        <Divider style={{background: '#969FAA'}}/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => {hideModalEmailNotOk()}} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalProrrogaOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <ExclamationCircleOutlined style={{fontSize: "49px", color:"#FFBA5C"}}/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Esta persona tiene una visita a esta facultad con menos de 6 meses de su finalización o tiene una visita vigente. Recomendamos realizar una prórroga.</div>
                        <Divider style={{background: '#969FAA'}}/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => {hideModalProrrogaOk()}} >ACEPTAR</Button>
                        </div>
                    </Modal>
                </div>
                <Spin spinning={this.state.visitaSinCargar} tip="Cargando Datos…">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <a href="/main">Menú principal</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Formulario</Breadcrumb.Item>
                </Breadcrumb>


                <Card>
                    {/*<Button className='global-secundario-button' style={{marginTop: '8px'}} onClick={() => {showModalNotOk()}} >
                        <SearchOutlined /> Mostrar modal
                    </Button> */}
                    <div style={{fontSize:"25px", color:"#1978B8"}}><b>Ingreso de Visitas</b></div>
                    <div style={{fontSize:"15px", color:"#5A6978"}}><b>Agrega una visita de manera presencial</b></div>
                    <br/>
                    <Form ref={form} layout={'vertical'} name="nest-messages" onFinish={onFinish} /*initialValues={initial}*/
                          validateMessages={validateMessages}>
                        <Row gutter={[16, 16]}>
                            <Col span={12}> 
                                <Form.Item
                                    name='rut_pasaporte'
                                    //label="RUT / Pasaporte"
                                    label={<label className='formvisit-label'>RUT / Pasaporte</label>}
                                    //style={{ color:"#5A6978", fontFamily:"Roboto", fontSize:"14px" }}
                                    rules={[{required: true, message: 'RUT o Pasaporte es requerido'}, {
                                        message: 'Formato RUT es 12345678-9 o de Pasaporte es P123456789',
                                        pattern: "^(\\d{1,2}\\d{3}\\d{3}-[\\dkK]|P\\w*)$"},
                                        {
                                        validator: async (rule, value) => {
                                            if(!value){
                                                return;
                                            }
                                            if (value[0] === 'P' && value.length > 5){
                                                return;
                                            }
                                            if (value.split("-").length < 2 || value.split("-")[1].length != 1) {
                                                throw new Error('RUT incorrecto.');
                                                return;
                                            }
                                            let rut = value.split("-")[0];
                                            let verificador = '' + value.split("-")[1];
                                            let verCalc = '';
                                            let sum = 0;
                                            let mul = 2;
                                        
                                            let i = rut.length;
                                            while (i--) {
                                            sum = sum + parseInt(rut.charAt(i)) * mul;
                                            if (mul % 7 === 0) { mul = 2; }
                                            else { mul++; }
                                            }
                                        
                                            const res = '' + sum % 11;

                                            if (res === '0'){
                                                verCalc = '0';
                                            } else {
                                                if (res === '1'){
                                                    verCalc = 'k';
                                                } else {
                                                    verCalc = '' + (11-res)
                                                }
                                            }
                                            if (verificador.toUpperCase() === verCalc.toUpperCase()){
                                                console.log("DV correcto")
                                                return;
                                            } else {
                                                console.log("DV incorrecto")
                                                throw new Error('RUT incorrecto.');
                                            }
                                        }
                                    } ]}
                                >
                                    <Input /* style={{borderColor:"#A3AEBB"}} */style={{ width: "100%" }} className='formvisit' placeholder="12345678-9 / P123456789" onBlur={this.handleonChangeRutPasaportev2} /* onSelect={(value,event)=> this.handleonChange_pais(value,event) */ />
                                </Form.Item>

                                <Form.Item name='nombres' label={<label className='formvisit-label'>Nombres</label>}
                                        rules={[{required: true, message: "Nombres son requeridos"}, {
                                            pattern: "^([^0-9]*)$",
                                            message: "Nombre no puede tener números"
                                        }]}><Input className='formvisit'/></Form.Item>

                                <Form.Item name='materno' label={<label className='formvisit-label'>Segundo apellido</label>}
                                        rules={[{
                                            pattern: "^([^0-9]*)$",
                                            message: "Apellido no puede tener números"
                                        }]}><Input className='formvisit'/></Form.Item>

                                <Form.Item name={['user', 'email']} label={<label className='formvisit-label'>Email</label>}
                                        rules={[{type: 'email', required: true, message: "Email es requerido"}]}>
                                            <Input className='formvisit'/></Form.Item>
                                <Form.Item name="estado_civil" label={<label className='formvisit-label'>Estado Civil</label>} rules={[{required: true, message: "Estado civil es requerido"}]}>
                                    <Select
                                        placeholder="Selecciona una opción"
                                        allowClear
                                        className='formvisit-select'
                                    >
                                        {this.state.estados_civiles.map(estCivil => (
                                            <Option
                                                value={parseInt(estCivil.id_estado_civil)}>{estCivil.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="birthday" label={<label className='formvisit-label'>Fecha de nacimiento</label>} rules={[{
                                    type: 'object',
                                    required: true,
                                    message: 'Fecha de nacimiento es requerida'
                                }]}>
                                    <DatePicker  style={{height: "35px", width: "238px", borderColor: "#A3AEBB"}} placeholder="Fecha de nacimiento" format={'YYYY-MM-DD'}/>
                                </Form.Item>

                                <Form.Item name='paterno' label={<label className='formvisit-label'>Primer apellido</label>}
                                        rules={[{
                                            required: true,
                                            message: "Primer apellido es requerido"
                                        }, {
                                            pattern: "^([^0-9]*)$",
                                            message: "Apellido no puede tener números"
                                        }]}><Input className='formvisit'/>
                                </Form.Item>

                                <Form.Item name="gender" label={<label className='formvisit-label'>Género</label>} rules={[{required: true, message: "Género es requerido"}]}>
                                    <Select
                                        placeholder="Selecciona una opción"
                                        allowClear
                                        className='formvisit-select'
                                    >
                                        <Option value="Masculino">Masculino</Option>
                                        <Option value="Femenino">Femenino</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name="phone"
                                    label={<label className='formvisit-label'>Teléfono</label>}
                                    rules={[{required: true, message: "Teléfono es requerido"}, {
                                        message: 'Formato Teléfono es 123456789',
                                        pattern: "^[0-9]*$"
                                    }]}
                                >
                                    <Input className='formvisit'/>
                                </Form.Item>
                                <Form.Item
                                    label={<label className='formvisit-label'>Nacionalidad</label>}
                                    name = "nacionalidad"
                                    rules={[{required: true, message: "Nacionalidad es requerida"}]}
                                    initialValue={window.ENV.CONSTANTE_ID_CHILE}
                                >
                                    <Select  
                                    className='formvisit-select' /* style={{ width: this.state.pais_length}} */ 
                                    placeholder="Selecciona una nacionalidad"
                                    optionFilterProp="children"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                        {this.state.paises.map(pais => (
                                            <Option value={pais.id_pais} key={pais.id_pais}>{pais.nacionalidad}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Space horizontal>
                                <div style={{color:"#34AAE9", fontWeight: "bold", fontSize: "16px"}}>Importante:</div><div style={{color:"#667487", fontSize: "16px"}}> Si la persona no es de Chile, los campos Ciudad y Región </div><div style={{color:"#667487", fontWeight: "bold", fontSize: "16px"}}> no son obligatorios</div>
                            </Space>
                        </Row>
                        <br/>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item
                                    label={<label className='formvisit-label'>País</label>}
                                    name={['address', 'country']}
                                    rules={[{required: true, message: "País es requerido"}]}
                                    initialValue={window.ENV.CONSTANTE_ID_CHILE}
                                >
                                    <Select  
                                    className='formvisit-select' /* style={{ width: this.state.pais_length}} */ 
                                    placeholder="Selecciona un país"
                                    onSelect={(value,event)=> this.handleonChange_pais(value,event)}
                                    optionFilterProp="children"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                        {this.state.paises.map(pais => (
                                            <Option value={pais.id_pais} key={pais.id_pais}>{pais.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={<label className='formvisit-label'>Ciudad</label>}
                                    name={['address', 'city']}
                                    rules={[{required: this.state.esChile, message: "Ciudad es requerida"}]}
                                >
                                    <Select 
                                    className='formvisit-select' /* style={{ width: this.state.ciudad_length }} */
                                    placeholder="Selecciona una Ciudad"
                                    optionFilterProp="children"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                        {this.state.esChile ? this.state.filtered_municipios.map(municipio => (
                                            <Option value={municipio.id_municipio} key={municipio.id_municipio}>{municipio.nombre}</Option>
                                        )) : this.state.filtered_ciudades.map(ciudad => (
                                            <Option value={ciudad.id_ciudad} key={ciudad.id_ciudad}>{ciudad.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label={<label className='formvisit-label'>Región</label>}
                                    name={['address', 'region']}
                                    rules={[{required: this.state.esChile, message: "Región es requerida"}]}
                                >
                                    <Select 
                                    className='formvisit-select' /* style={{ width: this.state.region_length}} */ 
                                    placeholder="Selecciona una región" 
                                    disabled={ !this.state.esChile}
                                    onSelect={(value,event)=> this.handleonChange_region(value,event)}
                                    optionFilterProp="children"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                        {this.state.filtered_regiones.map(region => (
                                            <Option value={region.id_region} key={region.id_region}>{region.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={<label className='formvisit-label'>Dirección</label>}
                                    name={['address', 'street']}
                                    rules={[{
                                        required: true, 
                                        message: 'Dirección es requerida'
                                        }]}
                                >
                                    <Input className='formvisit' style={{width:"100%"}} placeholder="Dirección"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider/>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                    <Form.Item label={<label><Row><div className='formvisit-required-icon'>*</div> <div className='formvisit-label'>Donde se dirige la visita</div> </Row></label>}>
                                        <Form.Item
                                            name={['unidad', 'reparticion']}
                                            rules={[{required: true}]}
                                            label="Repartición"
                                            noStyle
                                        >
                                            <Select 
                                                className='formvisit-select' 
                                                placeholder="Selecciona la repartición" 
                                                onSelect={(value,event)=> this.handleonChange_reparticion(value,event)}
                                                optionFilterProp="children"
                                                showSearch
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                >
                                                {this.state.reparticiones.map(reparticion => (
                                                    <Option  value={reparticion.id_organismo} key={reparticion.id_organismo}>{reparticion.nombre}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            name={['unidad', 'organismo']}
                                            rules={[{required: true}]}
                                            label="Organismo"
                                            noStyle
                                        >
                                            <Select 
                                                className='formvisit-select' 
                                                placeholder="Selecciona el organismo" 
                                                onSelect={(value,event)=> this.handleonChange_organismo(value,event)}
                                                optionFilterProp="children"
                                                style={{ marginTop: '25px' }}
                                                showSearch
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                >
                                                {this.state.organismos.map(organismo => (
                                                    <Option value={organismo.id_organismo} key={organismo.id_organismo}>{organismo.nombre}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            name={['unidad', 'departamento']}
                                            rules={[{required: true}]}
                                            label="Departamento"
                                            noStyle
                                        >
                                            <Select 
                                                className='formvisit-select' 
                                                placeholder="Selecciona el departamento"
                                                optionFilterProp="children"
                                                showSearch
                                                style={{ marginTop: '25px' }}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                >
                                                {this.state.departamentos.map(departamento => (
                                                    <Option value={departamento.id_organismo} key={departamento.id_organismo}>{departamento.nombre}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Form.Item>

                                    <Form.Item name="dates" label={<label className='formvisit-label'>Vigencia</label>} rules={[{
                                        required: true, message: 'Vigencia es requerida',
                                    },
                                    { validator: async (rule, value) => {
                                        if (!value){
                                            return
                                        }
                                        let hoy = new Date().toISOString().split('T')[0]
                                        let anioInicial = parseInt(value[0].format('YYYY-MM-DD').split('-')[0]) 
                                        let anioSiguiente = (anioInicial + 1) + '-' + value[0].format('YYYY-MM-DD').split('-')[1] + '-' + value[0].format('YYYY-MM-DD').split('-')[2]
                                        if(value[0].format('YYYY-MM-DD') < hoy){
                                            throw new Error('La fecha inicial no puede ser pasada');
                                        }
                                        if(anioSiguiente < value[1].format('YYYY-MM-DD')){
                                            throw new Error('La vigencia no puede superar 1 año')
                                        }
                                    }
                                    }
                                    
                                    ]}>
                                        <RangePicker /* className='formvisit-picker' */ style={{borderColor:"#A3AEBB"}} placeholder={["Inicio", "Término"]}/>
                                    </Form.Item>
                                </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={12}>
                                    <Form.Item name="sponsor" 
                                        label={<label className='formvisit-label'>Patrocinador</label>}
                                        rules={[{required: true, message: "Patrocinador es requerido"}]}>
                                        <Select              
                                            placeholder="Selecciona un patrocinador"
                                            allowClear
                                            className='formvisit-select'
                                            disabled
                                        >
                                            {this.state.funcionarios.length >= 1 ? this.state.funcionarios[0].map(sponsor => (
                                            <Option
                                                value={parseInt(sponsor.id_persona)}>{sponsor.nombres} {sponsor.paterno} {sponsor.materno}</Option>

                                        )) : this.state.funcionarios.map(sponsor => (
                                            <Option
                                                value={parseInt(sponsor.id_persona)}>{sponsor.nombres} {sponsor.paterno} {sponsor.materno}</Option>
                                        ))}
                                        </Select>
                                    </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                    { this.state.nivelTresSeleccionado ? <Button /* type="link" type="primary"*/ className='global-secundario-button' style={{marginTop: 30, marginLeft: 20}} onClick={() => {this.showModal()}} /* icon={<EyeOutlined />} */>
                                        <SearchOutlined /> BUSCAR PATROCINADOR
                                    </Button> :
                                    <Button /* type="link" */className='global-secundario-button' style={{marginTop: 30, marginLeft: 20}} disabled onClick={() => {this.showModal()}} /* icon={<EyeOutlined />} */>
                                        <SearchOutlined /> BUSCAR PATROCINADOR
                                    </Button> }
                                    </Col>
                                    </Row>

                                <Form.Item name="tipo" style={{marginTop: "27px"}} label={<label className='formvisit-label'>Tipo de visita</label>} rules={[{required: true,message: "Tipo de visita es requerido"}]}>
                                    <Select
                                        placeholder="Selecciona una opción"
                                        allowClear
                                        className='formvisit-select'
                                    >
                                        {this.state.visitas.map(tipo => (
                                            <Option value={tipo.id} key={tipo.id}>{tipo.tipo_visita}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider/>

                        <Modal
                            title={<div style={{color: "#4B5660", fontSize: "20px", fontWeight: "bold"}}> <div><SearchOutlined style={{marginRight:"10px"}}/> Buscar patrocinador</div></div>}
                            visible={this.state.visible}
                            onOk={null}
                            onCancel={this.handleCancel}
                            width={"633px"}
                            footer={null}
                        >   
                            <div style={{color:"#5A6978", fontSize: "13px", marginLeft:"56px"}}><b>Ud. está buscando en: </b></div>
                            <div style={{lineHeight:"19px", color:"#0A5DA6", fontSize: "16px", marginLeft:"56px"}}><b>{this.state.nombreFacultadSeleccionada}</b></div>
                            <div style={{color:"#5A6978", fontSize: "15px", marginLeft:"56px", marginBottom:"20px"}}>Puede buscar por rut o nombre, apellidos.</div>
                            <Form ref={formSponsor} layout={'vertical'} name="sponsorsForm"  onFinish={searchSponsor} initialValues={initialSponsor} >
                            <Form.Item name="checkRutSponsor">
                            <Radio.Group buttonStyle="solid" onChange={onChangeCheckbox}>
                                <Space size="middle">   
                                <Radio value="0"> </Radio>
                                    <Form.Item
                                        name='rut_pasaporte'
                                        label={<label className='formvisit-label'>Rut</label>}
                                        rules={[
                                            {
                                            validator: async (rule, value) => {
                                                if (!value){
                                                    return
                                                }
                                                if (value.split("-").length < 2 || value.split("-")[1].length != 1) {
                                                    throw new Error('Formato RUT es 12345678-9');
                                                    return;
                                                }
                                                let rut = value.split("-")[0];
                                                let verificador = '' + value.split("-")[1];
                                                let verCalc = '';
                                                let sum = 0;
                                                let mul = 2;
                                            
                                                let i = rut.length;
                                                while (i--) {
                                                sum = sum + parseInt(rut.charAt(i)) * mul;
                                                if (mul % 7 === 0) { mul = 2; }
                                                else { mul++; }
                                                }
                                            
                                                const res = '' + sum % 11;

                                                if (res === '0'){
                                                    verCalc = '0';
                                                } else {
                                                    if (res === '1'){
                                                        verCalc = 'k';
                                                    } else {
                                                        verCalc = '' + (11-res)
                                                    }
                                                }
                                                if (verificador.toUpperCase() === verCalc.toUpperCase()){
                                                    console.log("DV correcto")
                                                    return;
                                                } else {
                                                    console.log("DV incorrecto")
                                                    throw new Error('RUT incorrecto.');
                                                }
                                            }
                                        } ]}
                                    >   
                                    {this.state.checkValue==='0' ? <Input className='formvisit' placeholder="12345678-9"/> : <Input className='formvisit' placeholder="12345678-9" disabled/>}
                                    </Form.Item>
                                    </Space>
                                    <div>
                                    <Space size="middle">
                                    <Radio name="checkNombre" value="1"> </Radio>
                                        <Form.Item name='nombres' label={<label className='formvisit-label'>Nombre y/o apellidos</label>}
                                            rules={[{
                                                pattern: "^([^0-9]*)$",
                                                message: "El nombre no puede tener números"
                                            }]}>{this.state.checkValue==='1'  ? <Input className='formvisit' placeholder="Juan Pérez"/> : <Input className='formvisit' placeholder="Juan Pérez" disabled/> }
                                        </Form.Item>
                                    </Space>
                                    {this.state.ingresarNombres === '' ? null : <p style={{marginLeft:"50px", color:"red"}}>{this.state.ingresarNombres}</p>}
                                    </div>
                            </Radio.Group>
                            </Form.Item>
                            <Divider/>
                            <div style={{textAlign: 'right'}}>
                                <Space size="middle" >
                                    {/*  <Button onClick={() => {this.datosCamposSponsor()}} > Boton </Button> */}
                                    <Button
                                    className="global-secundario-button"
                                        onClick={() => {this.handleCancel()}}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        //type="primary"
                                        className="global-principal-button"
                                        htmlType="submit"
                                        //loading={loadings[0]}
                                        loading={this.state.loadingSponsorButton}
                                    >
                                        Buscar
                                    </Button>
                                </Space>
                            </div>
                            </Form>
                            {renderSponsors()}
                        </Modal>

                        <Form.Item name="photo" label={<label><Row><div className='formvisit-required-icon'>*</div> <div className='formvisit-label'>Foto de perfil</div> </Row></label>}
                                   rules={[{required: false, message: 'La foto es requerida'}]}>
                            <ImgCrop grid rotate modalTitle="Editar imagen" aspect="0.75" /* modalWidth={this.state.modalWidth} beforeCrop={this.beforeCrop}*/ >
                                <Upload
                                    name="avatar"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    customRequest={dummyRequest}
                                    beforeUpload={beforeUpload}
                                    onChange={this.handleChange}
                                >
                                    {imageUrl ? <img style={{width:"100%"}} src={imageUrl} alt="avatar"/> : uploadButton}
                                </Upload>
                            </ImgCrop>
                        </Form.Item>
                        {this.state.visita.ID_FORMULARIO ? <Avatar src={`${this.state.visita.ID_FORMULARIO.FotoPersona}`} shape="square" style={{width: "20%", height:"27%"}}/>: null}
                        <br/>
                        <br/>
                        <b style={{color:"#4B5660"}}>Características que debe tener la fotografía</b>:
                        <ol style={{color:"#4B5660"}}>
                            <li>Fotografía en color: Sin sombras, reflejos o filtros.</li>
                            <li>Encuadre: Sólo rostro, frontal y centrada (área de cobertura estándar de foto
                                carnet). No incluir número de carnet.
                            </li>
                            <li>No utilizar anteojos, sombreros ni otros accesorios que cubran total o parcialmente
                                el rostro.
                            </li>
                            <li>Fondo: Color blanco o crema, sin texturas, diseños ni paisajes de fondo.</li>
                            <li>La fotografía no debe ser escaneada ni verse borrosa.</li>
                        </ol>
                        <Divider/>
                        <Form.Item>
                            <Button
                                className='formvisit-send-button'
                                onClick={() => {this.submitForm()}}
                                loading={this.state.submitButtonload}
                            >
                                ENVIAR
                            </Button>
                            {/* <Button 
                                type="primary" 
                                htmlType="button"
                                onClick={this.datosCampos}
                            >
                                Borrar campos
                            </Button> */}
                        </Form.Item>
                    </Form>

                    <Row>
                        <div className='formvisit-required-icon'>*</div> <div>Campos obligatorios</div>
                    </Row>
                </Card>
                
                </Spin>
            </div>
        );
    }
}

export default FormVisit;